import { ISelectValue } from 'constants/globalTypes'

export type TaskPriority = 'Low' | 'Normal' | 'High' | 'Critical'

export const TASK_PRIORITIES: TaskPriority[] = ['Low', 'Normal', 'High', 'Critical']

export const TASK_PRIORITY_COLORS: Record<TaskPriority, string> = {
  Low: '#8A8A8A',
  Normal: '#B0B0B0',
  High: '#F4D03F',
  Critical: '#E74C3C',
}

export interface ITaskRow {
  id: number
  taskTemplate: string
  department: string
  location: string | null
  priority: TaskPriority
  assignment: string
  assignees: string | null
  startAt: string
  evidenceRequired: boolean
}

export const ASSIGNMENT_AUTO = 1
export const ASSIGNMENT_PICK = 2

export const assignmentOptions: ISelectValue[] = [
  { label: 'Auto-assign (Resolver Engine picks)', value: ASSIGNMENT_AUTO },
  { label: 'Pick Worker(s)', value: ASSIGNMENT_PICK },
]

export const taskTemplateOptions: ISelectValue[] = [
  { label: 'Equipment inspection', value: 1 },
  { label: 'Safety walkdown', value: 2 },
  { label: 'Pre-start checklist', value: 3 },
  { label: 'Haul route verification', value: 4 },
]

export interface IAddTaskFormState {
  taskTemplate: ISelectValue | null
  department: ISelectValue | null
  location: ISelectValue | null
  priority: TaskPriority
  assignment: ISelectValue
  startAt: Date | null
  notes: string
  evidenceRequired: boolean
  workers: ISelectValue[]
}
